var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.83 41.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5bcbf5;}.cls-2{fill:#ffcb39;}.cls-3{fill:#ff9600;}.cls-4{fill:#007bbd;}.cls-5{fill:#c7f4f9;}.cls-6{fill:#5c546a;}.cls-7{fill:#e87e04;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rocket_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rocket"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.31,41.57a7.89,7.89,0,0,0,1.91-1,9.68,9.68,0,0,0-6-17.66A10,10,0,0,0,7.3,24.57,10.1,10.1,0,0,0,5.67,26a13.83,13.83,0,1,1,26.81,6.43,13.67,13.67,0,0,1-5.35,7A13.41,13.41,0,0,1,16.31,41.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.81,2.35a.92.92,0,0,0-.53-.78A21.75,21.75,0,0,0,36.75,3.9C32.63,6.7,22.38,15.2,12.89,23.65a3.69,3.69,0,0,0-.59,4.82l4.05,5.94a3.69,3.69,0,0,0,4.7,1.2c11.33-5.74,23-12.19,27.1-15A21.75,21.75,0,0,0,57.81,2.35Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.33,31.44l-2-3a3.69,3.69,0,0,1,.59-4.82C22.38,15.2,32.63,6.7,36.75,3.9A21.75,21.75,0,0,1,57.28,1.57a.92.92,0,0,1,.37.32h0Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.8,17.34a5.52,5.52,0,1,1,1.45-7.67,5.52,5.52,0,0,1-1.45,7.67Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.28,1.57A21.48,21.48,0,0,0,46.46.17l8.71,12.77A21.48,21.48,0,0,0,57.81,2.35a.92.92,0,0,0-.53-.78Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M57.66,1.89a.92.92,0,0,0-.38-.32A21.48,21.48,0,0,0,46.46.17l4.35,6.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.8,17.34a5.52,5.52,0,0,0,1.45-7.67l-9.12,6.22a5.52,5.52,0,0,0,7.67,1.45Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M36.37,16.41a6.44,6.44,0,1,1,9,1.69,6.45,6.45,0,0,1-9-1.69Zm9.12-6.22a4.6,4.6,0,1,0-1.21,6.39,4.61,4.61,0,0,0,1.21-6.39Zm0,0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "flame"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M11.39,38.49C7.39,41.21,0,41.22,0,41.22s2.33-6.63,6.7-9.61a4.16,4.16,0,0,1,4.69,6.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.75,36.54c-2.65,1.81-7.56,1.81-7.56,1.81S5.74,34,8.64,32a2.76,2.76,0,0,1,3.12,4.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.72,35.37c-1.61,1.1-4.61,1.1-4.61,1.1a9,9,0,0,1,2.71-3.89,1.68,1.68,0,0,1,1.9,2.78Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.e46019d4c7684ff9d35db03b7aae8edd.svg";
export { ForwardRef as ReactComponent };